import template from './toggle-box.html'
import css from './toggle-box.less'
import { ToggleBoxController } from './toggle-box.controller.js'

export const ToggleBoxComponent = {
  template: template,
  controller: ToggleBoxController,
  controllerAs: 'ToggleBoxController',
  transclude: true,
  bindings: {
    title: '@',
    size: '@',
    startOpen: '=',
    notToggleable: '='
  }
}



// WEBPACK FOOTER //
// ./src/client/common/uiComponents/ToggleBox/toggle-box.component.js